<template lang="pug">
  #admin-super-document-manager
    DocumentManagerTable
</template>

<script>
import DocumentManagerTable from "@@/DocumentManager/DocumentManagerTable.vue";

export default {
  name: "AdminSuperDocumentManager",
  components: {
    DocumentManagerTable
  }
};
</script>
